<template>
  <div class="pages-table">
    <empty-card
      :table="true"
      :title="$t(title)"
    >
      <ok-table
        ref="datatable"
        :config="config"
        class="pages-table"
        @edit="handleEdit"
        @block="handleBlock"
        @check-permissions="handleCheckPermissions"
        @add-permissions="handleAddPermissions"
        @remove-menu="handleRemoveMenu"
        @delete="handleDelete"
        @renew="handleRenew"
        @add-menu="handleAddMenu"
        @owners="opwnOwnersModal"
        @feature="openFeaturesModal"
        @stop-comments="handleStopComments"
        @stop-replies="handleStopReplies"
      >
        <template
          slot="name-column"
          slot-scope="{props}"
        >
          <a
            :href="`https://facebook.com/${props.row.page_id}`"
            target="_blank"
            :class="props.row.deleted?'text-danger':'text-primary'"
          >
            {{ props.row.name }}
          </a>

        </template>
        <template
          slot="expired-column"
          slot-scope="{props}"
        >
          <b-badge
            :variant="props.row.expired?'danger':'primary'"
          >
            {{ isInstagram?props.row.expires_at:props.row.expired_date }}
          </b-badge>

        </template>
        <template
          v-if="isInstagram"
          v-slot:is_direct-column="{props}"
        >
          <b-badge
            :variant="props.row.is_direct ? 'success' : 'secondary'"
          >
            {{ $t(`general.${props.row.is_direct ? 'yes' : 'no'}`) }}
          </b-badge>
        </template>
        <template
          v-slot:comment_algo-column="{props}"
        >
          <div class="d-flex">
            <b-badge
              class="mx-1"
              :variant="`${props.row.comment_algo_enable?'success':'danger'}`"
            >
              {{ $t(`forms.${props.row.comment_algo_enable?'active':'inactive'}`) }}
            </b-badge>
          </div>
        </template>
        <template
          v-slot:ai_enabled-column="{props}"
        >
          <b-badge
            :variant="props.row.ai_enabled ? 'success' : 'danger'"
          >
            {{ $t(`general.${props.row.ai_enabled ? 'yes' : 'no'}`) }}
          </b-badge>
        </template>
        <template
          v-slot:liker-column="{props}"
        >
          <div class="d-flex">
            <b-badge
              class="mx-1"
              :variant="`${props.row.use_as_liker?'success':'danger'}`"
            >
              {{ $t(`forms.${props.row.use_as_liker?'active':'inactive'}`) }}
            </b-badge>
            <b-form-checkbox
              switch
              :unchecked-value="0"
              :checked="props.row.use_as_liker"
              :value="1"
              @change="handlePageLiker(props)"
            />
          </div>
        </template>
        <template
          slot="package-name-column"
          slot-scope="{props}"
        >
          <b-badge
            variant="primary"
          >
            {{ getPackageName(props.row) }}
          </b-badge>

        </template>
        <template
          slot="package-price-column"
          slot-scope="{props}"
        >
          <b-badge
            variant="success"
          >
            {{ getPackagePrice(props.row) }}
          </b-badge>

        </template>
        <template
          slot="unpaid_invoices_count-column"
          slot-scope="{props}"
        >
          <b-badge
            variant="danger"
            @click="showInvoicesModal=true,selectedPage=props.row"
          >
            {{ getInvoicesCount(props.row.invoices) }}
          </b-badge>

        </template>
        <template
          slot="invoices_count-column"
          slot-scope="{props}"
        >
          <b-badge
            variant="info"
            @click="showInvoicesModal=true,selectedPage=props.row"
          >
            {{ props.row.invoices && props.row.invoices.length }}
          </b-badge>

        </template>
        <template
          slot="features-column"
          slot-scope="{props}"
        >
          <div class="demo-inline-spacing">
            <b-badge
              v-for="feature in props.row.features"
              :key="feature.id"
            >
              {{ feature.name }}
            </b-badge>
          </div>

        </template>
      </ok-table>
    </empty-card>
    <page-owners
      v-if="!isInstagram"
      v-model="showOwnersModal"
      :page="selectedPage"
    />
    <page-edit-modal
      v-model="showEditModal"
      :page="selectedPage"
      :is-instagram="isInstagram"
      @updated="refreshTable"
    />
    <invoices-modal
      v-model="showInvoicesModal"
      :page="selectedPage"
    />
    <add-features-modal
      v-model="showFeaturesModal"
      :page="selectedPage"
      @updated="refreshTable"
    />
  </div>
</template>

<script>
import { BBadge, BFormCheckbox } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import PageApi from '@/api/page'
import PageOwners from '@/views/admin/pages/components/PageOwnersModal'
import PageEditModal from '@/views/admin/pages/components/PageEditModal'
import InvoicesModal from '@/views/admin/pages/components/InvoicesModal'
import InstagramAccountsApi from '@/api/instagram/account'
import AddFeaturesModal from '@/views/admin/pages/components/AddFeaturesModal.vue'
import FeaturesApi from '@/api/features'

export default {
  components: {
    AddFeaturesModal,
    InvoicesModal,
    PageEditModal,
    PageOwners,
    EmptyCard,
    OkTable,
    BBadge,
    BFormCheckbox,
  },
  props: {
    isInstagram: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: 'menu.pages',
    },
  },
  data() {
    return {
      showOwnersModal: false,
      showEditModal: false,
      showInvoicesModal: false,
      showFeaturesModal: false,
      selectedPage: {},
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'pages/currentPageId',
      currentPage: 'pages/currentPage',
    }),
  },
  watch: {
    currentPageId() {
      this.refreshTable()
    },
  },
  async mounted() {
    await this.$store.dispatch('subscription/GET_PACKAGES')
    await this.$store.dispatch('auth/FETCH_REFERRALS')
  },
  methods: {
    refreshTable() {
      this.selectedPage = {}
      this.$refs.datatable.loadItems()
    },
    opwnOwnersModal(props) {
      this.showOwnersModal = true
      this.selectedPage = props.row
    },
    openFeaturesModal(props) {
      this.showFeaturesModal = true
      this.selectedPage = props.row
    },
    handleEdit(props) {
      this.showEditModal = true
      this.selectedPage = props.row
    },
    getPackageName(row) {
      return row?.package?.name ?? 'غير محدد'
    },
    getPackagePrice(row) {
      return row?.package?.price ?? 'غير محدد'
    },
    handleDelete(data) {
      this.$okConfirm(this.$t('page.delete-page-message'), {
        preConfirm: () => (this.isInstagram ? InstagramAccountsApi.deleteAccount(data.row.id) : PageApi.deletePage(data.row.id))
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleRenew(data) {
      this.$okConfirm(this.$t('page.renew-page-message', { page: data.row.name }), {
        confirmButtonText: this.$t('forms.submit'),
        preConfirm: () => (this.isInstagram ? InstagramAccountsApi.renewAccount(data.row.id) : PageApi.renewPage(data.row.id))
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleStopComments(data) {
      this.$okConfirm(this.$t('page.stop-page-comments', { page: data.row.name }), {
        confirmButtonText: this.$t('forms.submit'),
        preConfirm: async () => PageApi.stopComments(data.row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleStopReplies(data) {
      this.$okConfirm(this.$t('page.stop-page-replies', { page: data.row.name }), {
        confirmButtonText: this.$t('forms.submit'),
        preConfirm: async () => PageApi.stopReplies(data.row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleBlock(data) {
      this.$okConfirm(this.$t('page.block-message'), {
        confirmButtonText: this.$t('forms.submit'),
        preConfirm: () => (this.isInstagram ? InstagramAccountsApi.blockAccount(data.row.id) : PageApi.blockPage(data.row.id))
          .then(response => {
            if (response.error === 0) this.$notifySuccess(response.message)
            else this.$notifyError(response.message)
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handlePageCommenter(data) {
      this.$okConfirm(this.$t('general.process-confirm'), {
        confirmButtonText: this.$t('forms.submit'),
        showCancel: true,
        preConfirm: () => FeaturesApi.togglePageCommenter(data.row.id)
          .then(response => {
            if (response.error === 0) {
              this.$notifySuccess(response.message)
            } else {
              this.$notifyError(response.message)
            }
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handlePageLiker(data) {
      this.$okConfirm(this.$t('general.process-confirm'), {
        confirmButtonText: this.$t('forms.submit'),
        showCancel: true,
        preConfirm: () => FeaturesApi.togglePageLiker(data.row.id)
          .then(response => {
            if (response.error === 0) {
              this.$notifySuccess(response.message)
            } else {
              this.$notifyError(response.message)
            }
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleAddPermissions(data) {
      this.$okConfirm(this.$t('page.add-permissions-message'), {
        confirmButtonText: this.$t('forms.submit'),
        preConfirm: () => (this.isInstagram ? InstagramAccountsApi.addPermissions(data.row.id) : PageApi.addPermissions(data.row.id))
          .then(response => {
            if (response.error === 0) this.$notifySuccess(response.message)
            else this.$notifyError(response.message)
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleCheckPermissions(data) {
      (this.isInstagram ? InstagramAccountsApi.checkPermissions(data.row.id) : PageApi.checkPermissions(data.row.id))
        .then(response => {
          if (response.error === 0) this.$notifySuccess(response.message)
          else this.$notifyError(response.message)
        })
        .catch(e => this.$notifyError(e))
    },
    handleRemoveMenu(data) {
      this.$okConfirm(this.$t('page.remove-menu-message'), {
        preConfirm: () => (this.isInstagram ? InstagramAccountsApi.deleteMenu(data.row.id) : PageApi.deleteMenu(data.row.id))
          .then(response => {
            if (response.status === 'success') this.$notifySuccess(response.message)
            else this.$notifyError(response.message)
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleAddMenu(data) {
      this.$okConfirm(this.$t('page.add-menu-message'), {
        confirmButtonText: this.$t('forms.submit'),
        preConfirm: () => (this.isInstagram ? InstagramAccountsApi.addMenu(data.row.id) : PageApi.addMenu(data.row.id))
          .then(response => {
            if (response.status === 'success') this.$notifySuccess(response.message)
            else this.$notifyError(response.message)
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    getInvoicesCount(invoices) {
      return (invoices ?? []).filter(i => !i.paid)?.length ?? 0
    },
  },
}
</script>
